import React, { useEffect, useState } from "react";

import "./Information-Card-Pc.scss";

//imports for user data
import { useSelector } from "react-redux";
import DonutPercentage from "./DonutPercentage";

//import resize function
import {vw,vh} from "../../../assets/reusableComponents/resizeFunction"




const InformationCardPc = ({ percentage, Title ,setTableToView,valueToSet}) => {

  
  const circleContainerStyle = {
    textAlign: "center",
    marginTop: vh(20),

  };


  const categoryListStyle = {
    marginTop: vh(20),
    marginLeft: vw(10),
  };

  const categoryStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: vh(5),
    fontFamily: "Poppins, sans-serif",
    fontWeight: "400",
  };

  const dotStyle = {
    width: vh(10),
    height: vh(10),
    borderRadius: "50%",
    marginRight: "0px",
  };

  const labelStyle = {
    flexGrow: 1,
    marginLeft: vw(10),
    fontFamily: "Karla, sans-serif",
    fontWeight: "700!important",
    textAlign: "left",
  };



  return (
    <div className="individual-card">
      <button
        style={{
          margin: 0,
          padding: `${vh(10)} ${vh(20)}`,
          background: "none",
          border: "none",

          width: "100%",
        }}
        onClick={() => {
          if (setTableToView && valueToSet) {
            console.log("clicked");
            setTableToView(valueToSet);
          }
        }}
      >
        <div className="top-half">
          <div className="title-and-date">
            <div className="title">{Title}</div>
            <div className="date">Data from 10/9/2018</div>
          </div>
          <div className="right-half"></div>
        </div>
        <div className="bottom-half">
          <div style={circleContainerStyle}>
            <DonutPercentage percentage={percentage} />
          </div>
          {/* list of categories */}
          <div style={categoryListStyle}>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#B99963" }}></span>
              <span style={{ ...labelStyle, color: "#B99963" }}>0-25%</span>
              {/* <span style={valueStyle}>%</span> */}
            </div>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#64A371" }}></span>
              <span style={{ ...labelStyle, color: "#64A371" }}>26-50%</span>
              {/* <span style={valueStyle}></span> */}
            </div>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#377771" }}></span>
              <span style={{ ...labelStyle, color: "#377771" }}>51-75%</span>
              {/* <span style={valueStyle}>%</span> */}
            </div>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#293947 " }}></span>
              <span style={{ ...labelStyle, color: "#293947 " }}>76-100%</span>
              {/* <span style={valueStyle}>%</span> */}
            </div>
            {/* {cardData?.fields?.[3] && <>
             
            </>} */}
          </div>
        </div>
      </button>

      {/* <div style={circleContainerStyle}>
                <div style={circleStyle}>
                    <div style={circleBeforeStyle}></div>
                    <span style={amountStyle}>$8,295</span>
                    <span style={percentageStyle}>↓ 2.1%</span>
                </div>
            </div> */}
    </div>
  );
};

export default InformationCardPc;
